<template>
  <div class="content">
    <div class="header">
      <div style="margin: 5px 0">
        <div>
          <SelectCdjProjectHeader @onHeader="onHeader">
            <el-select v-model="where.group_id" @change="searchList()" class="m-2" filterable placeholder="角色" clearable size="mini">
              <el-option
                v-for="item in [
                 {id: 25, name: '前台接待'},
                 {id: 26, name: '前台收银'},
                 {id: 18, name: '管家助理'},
                 {id: 19, name: '管家主任'},
                 {id: 23, name: '大管家'},
                 {id: 10, name: '项目经理'},
                 {id: 24, name: '分公司管家经理'},
                 {id: 11, name: '战区负责人'},
              ]"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <el-select v-model="where.is_update" @change="searchList()" class="m-2" filterable placeholder="是否认证" clearable size="mini">
              <el-option
                v-for="item in [{name:'未更新',value:1},{name:'已更新',value:2}]"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
            <!--          <el-input-->
            <!--            style="width: 240px"-->
            <!--            placeholder="请输入房产"-->
            <!--            v-model="where.text"-->
            <!--            clearable>-->
            <!--          </el-input>-->
            <el-button type="primary" size="mini" @click="searchList()">搜索</el-button>
          </SelectCdjProjectHeader>
        </div>
      </div>
    </div>

    <div class="header-tip">
      账号数量：{{pageData.total}}
    </div>

    <div class="table-wrap">
      <el-table
        v-loading="loading"
        v-if="pageData" :data="pageData.list"
        border
        style="width: 100%">
        <el-table-column
          prop="project_name"
          label="项目" width="200"></el-table-column>
        <el-table-column
          prop="area_name"
          label="区域"
          width="200">
        </el-table-column>
        <el-table-column
          prop="butler_name"
          label="姓名"
          width="150">
        </el-table-column>
        <el-table-column
          prop="group_name"
          label="职务"
          width="150">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="电话"
          width="180">
        </el-table-column>
        <el-table-column
          prop="house_count"
          label="房产数" width="100">
        </el-table-column>
        <el-table-column
          prop="状态"
          label="状态">
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                     :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                     @current-change="pageChange"></el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import ButlerHttp from "./common/ButlerHttp";
import SelectCdjProjectHeader from "./components/common/SelectCdjProjectHeader";

export default {
  name: "ProjectAccount",
  components: {SelectCdjProjectHeader},
  data(){
    return{
      loading: false,
      where: {
        text:"",
        is_update:"",
        group_id:"",
        start_time:moment(new Date()).format("YYYY-MM-DD"),
        end_time:moment(new Date()).format("YYYY-MM-DD")
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      reginWhere:{
        type_id:"",
        type_list:[],
        project_region:"",
        project_region_list:[],
        project_name:"",
        project_list:[],
        group_by:"",
        area_id:"",
        area_list:[],
        project_ids:[]
      },
      countObj:{
        count1:0,
        count2:0
      }
    }
  },
  activated() {
    const that=this;
  },
  methods:{
    searchList(){
      this.pageData= {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      };
      this.getList()
      this.getCount()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;

      ButlerHttp.post("Legal/projectAccount", {
        ...where,
        page: that.pageData.page,
        page_size: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    getCount() {
      const that = this;
      let where = ERP.reJson(that.where)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;

      // ERP.postRequest({
      //   url: "admin/Legal/propertyCertificationMonthStatistics",
      //   data: {
      //     ...where
      //   }
      // }, res => {
      //   if (res.code) {
      //     that.countObj = res.data
      //   }
      // })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    onHeader(data){
      const that=this;
      that.reginWhere.type_id=data.type_id;
      that.reginWhere.type_list=data.type_list;
      that.reginWhere.project_region=data.project_region;
      that.reginWhere.project_region_list=data.project_region_list;
      that.reginWhere.project_region_level=data.project_region_level;
      that.reginWhere.project_name=data.project_name;
      that.reginWhere.project_list=data.project_list;
      that.reginWhere.group_by=data.group_by;
      that.reginWhere.area_id=data.area_id;
      that.reginWhere.area_list=data.area_list;
      that.reginWhere.project_ids=data.project_ids;
      that.reginWhere.level=data.level;
      that.is_loading=true;

      that.pageChange(1)
      that.getCount()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "common";
.content{
  padding: 10px;
  margin-left: 10px;

  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: inline-block;
  }

  .pagination-wrap{
    margin-top: 10px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/ProjectAccount.vue